import { useChapter } from '@/context/ChapterContext'

export default function ChapterMenuButton() {
  const { setShowChapterMenu } = useChapter()
  return (
    <button type={'button'} onClick={() => setShowChapterMenu(true)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
        <title>Chapter select</title>
        <path
          d="M5.98047 30.8335H35.9805V27.5002H5.98047V30.8335ZM5.98047 22.5002H35.9805V19.1668H5.98047V22.5002ZM5.98047 10.8335V14.1668H35.9805V10.8335H5.98047Z"
          fill="white"
        />
      </svg>
    </button>
  )
}

export { ChapterMenuButton }
